import ImportParticipantsModal from './ImportParticipantsModal';

export default ImportParticipantsModal;
